const BASE = process.env.REACT_APP_API_URL;

async function apiFetch(path, options = {}) {
  const resp = await fetch(`${BASE}${path}`, {
    headers: { 'Content-Type': 'application/json', ...options.headers },
    ...options,
  });
  if (!resp.ok) {
    const err = await resp.json().catch(() => ({ error: `HTTP ${resp.status}` }));
    const error = new Error(err.error || err.detail || err.message || `HTTP ${resp.status}`);
    error.status = resp.status;
    throw error;
  }
  return resp.json();
}

export const analyzeArticle = (body) =>
  apiFetch('/analyze', { method: 'POST', body: JSON.stringify(body) });

export const getAssetTimeline = (symbol, params = {}) => {
  const q = new URLSearchParams(params).toString();
  return apiFetch(`/asset/${symbol}/timeline${q ? '?' + q : ''}`);
};

export const getAssetLatest = (symbol, limit = 10, from_date = null) => {
  const params = new URLSearchParams({ limit });
  if (from_date) params.append('from_date', from_date);
  return apiFetch(`/asset/${symbol}/latest?${params}`);
};

export const getAssetSparkline = (symbol) =>
  apiFetch(`/asset/${symbol}/sparkline`);

export const getDashboardLatest = (since) =>
  apiFetch(`/dashboard/latest${since ? '?since=' + encodeURIComponent(since) : ''}`);

export const getDashboardFeed = (limit = 50) =>
  apiFetch(`/dashboard/feed?limit=${limit}`);

export const getDashboardHeatmap = (days = 7, assets = 10) =>
  apiFetch(`/dashboard/heatmap?days=${days}&assets=${assets}`);

export const getPriceHistory = (symbol, days = 7) =>
  apiFetch(`/price/${symbol}?days=${days}`);

export const getDomains = () => apiFetch('/domains');

export const getAssets = () => apiFetch('/assets');

export const getHealth = () => apiFetch('/health');

export const explainSentiment = (article_id, symbol) =>
  apiFetch(`/explain/${article_id}/${symbol}`);
